
    import QuestionMixin from '@/components/JobView/Apply/Questions/QuestionMixin';
    import C1Upload from '@/C1Components/C1Upload';

    export default {
        name: 'QuestionUpload',

        components: {
            C1Upload,
        },

        mixins: [
            QuestionMixin,
        ],

        data() {
            return {
                file: {},
                questionId: `question_upload_${this.question.id}`,
                fileTypes: '',
            };
        },

        computed: {
            answer() {
                return this.file.uuid || '';
            },

            validation() {
                let validated = false;
                if (this.file.uuid) {
                    const fileExtension = this.file.filename.split('.')[this.file.filename.split('.').length - 1];
                    const valRules = this.validationRules.split('|');
                    if (this.validationRules.includes('ext')) {
                        valRules.forEach((rule) => {
                            if (rule.includes('ext')) {
                                this.fileTypes = rule.replace('ext:', '');
                                if (rule.toLowerCase().includes(fileExtension.toLocaleString())) {
                                    validated = true;
                                }
                            }
                        });
                    } else {
                        validated = true;
                    }
                }
                return validated ? this.file.uuid : '';
            },

            validationRequired() {
                if (this.validationRules.includes('required') || (this.validationRules.includes('ext') && this.file.uuid)) {
                    return 'required';
                } else {
                    return '';
                }
            },
        },

        methods: {
            onFileUploaded(file) {
                this.file = file;
            },

            onFileDeleted() {
                this.file = '';
            },
        },
    };
